import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';
import DisForm from './DisForm';

function DisBanner() {
    return (
        <Fragment>
            <div className='container governancemain motor' >
                <div className='row arrticleAndBlogs'>
                    <div className='col-sm-12 heads govbanner discount'>
                        <Fade up delay={500}><h2 className="oswald">Discount Center</h2></Fade>
                    </div>
                    <div className='col-sm-12 heads text mymaxheight'>
                       <DisForm/>
                    </div>                
                </div>
            </div>
        </Fragment>
    )
}

export default DisBanner